import { useApiClient } from '../../hooks/useApiClient'

export function useMatchLink() {
  const $api = useApiClient()

  return $api.useMutation('post', '/supplier_rec/match/link')
}
